import React from "react";
import HeroImage from "../herosection/imgaesection/HeroImage";
import HeroText from "../herosection/textsection/HeroText";

export default function HeroPage() {
  return (
    <section className="relative w-full h-[850px] overflow-hidden">
      <HeroImage />

      <div className="absolute inset-0 flex items-center justify-center px-4 md:px-10">
        <HeroText />
      </div>

     
      <div className="absolute inset-0 bg-black opacity-30 z-0"></div>
    </section>
  );
}
